module.exports = __webpack_public_path__ + "static/img/icon-MNL.1bad398.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-MNL.svg
// module id = pEa3
// module chunks = 1